/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_InstagramInputs */

const en_us2_onboarding_how_heard_instagram = /** @type {(inputs: Onboarding_How_Heard_InstagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const pt_br2_onboarding_how_heard_instagram = /** @type {(inputs: Onboarding_How_Heard_InstagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const es_419_onboarding_how_heard_instagram = /** @type {(inputs: Onboarding_How_Heard_InstagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const pt_pt2_onboarding_how_heard_instagram = /** @type {(inputs: Onboarding_How_Heard_InstagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const fr_fr2_onboarding_how_heard_instagram = /** @type {(inputs: Onboarding_How_Heard_InstagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const de_de2_onboarding_how_heard_instagram = /** @type {(inputs: Onboarding_How_Heard_InstagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

const it_it2_onboarding_how_heard_instagram = /** @type {(inputs: Onboarding_How_Heard_InstagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram`)
};

/**
* | output |
* | --- |
* | "Instagram" |
*
* @param {Onboarding_How_Heard_InstagramInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_instagram = /** @type {((inputs?: Onboarding_How_Heard_InstagramInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_InstagramInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_instagram(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_instagram(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_instagram(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_instagram(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_instagram(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_instagram(inputs)
	return en_us2_onboarding_how_heard_instagram(inputs)
});
export { onboarding_how_heard_instagram as "onboarding.how_heard.instagram" }